import { isNullOrUndefined } from 'util';
import { Component, HostListener, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { EncrdecrService } from '../../Auth/encrdecr.service';
import { IsValidMobile, IsValidEmail, NumberOnly } from 'src/app/validation';
import { ProfileService } from '../../services/profile.service';
declare var $: any;
@Component({
  selector: 'IFA-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss', './../ifacss.scss']
})
export class HeaderComponent implements OnInit {
  LetsTalkForm: FormGroup;
  CompanyLogo: any;
  isLoaded = false;
  Googleplaylink: any;
  logoimage: string;
  subBrokerID_mail: string;
  scheduleofcall: any;
  dataSource: any;
  LogoInterval: any;
  UploadedQR: any;
  IsMobile: boolean = false;
  WhatsAppQR: any = '';
  WhatsAppLink: any;
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.SetViewPort(event.target.innerWidth);
  }
  constructor(
    private EncrdecrService: EncrdecrService,
    public sanitizer: DomSanitizer,
    private router: Router,
    private fb: FormBuilder,
    private profileService: ProfileService
  ) {
    this.LetsTalkForm = this.fb.group({
      customer_name: ['', [Validators.required]],
      Mobile_No: ['', [Validators.required, Validators.pattern(IsValidMobile)]],
      customer_Email: [
        '',
        [Validators.required, Validators.pattern(IsValidEmail)]
      ],
      Statein: ['', [Validators.required]],
      city_name: ['', [Validators.required]],
      customer_Meassage: ['', [Validators.required]],
      talk_schedule1: ['', []]
    });
  }
  get f() {
    return this.LetsTalkForm.controls;
  }
  ngOnInit() {
    this.subBrokerID_mail = sessionStorage.getItem('ihjt45h45=sb');
    // this.CompanyLogo = 'data:image/png;base64,'+ this.logoimage;
    this.logoimage = sessionStorage.getItem('lkighty445dh==');
    this.LogoInterval = setInterval(() => {
      debugger;
      console.log('INSIDE INTERVAL');
      if (this.logoimage == '' || isNullOrUndefined(this.logoimage)) {
        console.log('STILL INSIDE INTERVAL');
        this.logoimage = sessionStorage.getItem('lkighty445dh==');
        this.CompanyLogo = this.sanitizer.bypassSecurityTrustResourceUrl(
          'data:image/jpg;base64,' + this.logoimage
        );
        this.Googleplaylink = this.sanitizer.bypassSecurityTrustResourceUrl(
          sessionStorage.getItem('ihjt45h45=t')
        );

      } else {
        console.log('ENDED INTERVAL');
        this.logoimage = sessionStorage.getItem('lkighty445dh==');
        this.CompanyLogo = this.sanitizer.bypassSecurityTrustResourceUrl(
          'data:image/jpg;base64,' + this.logoimage
        );
        clearInterval(this.LogoInterval);
      }

      let UploadedQR = this.sanitizer.bypassSecurityTrustResourceUrl(
        'data:image/jpg;base64,' + sessionStorage.getItem('lkighty445dh==QR')
      );
      if (UploadedQR && UploadedQR != 'null') {
        this.UploadedQR = UploadedQR;
      }

      let WhatsAppQR = this.sanitizer.bypassSecurityTrustResourceUrl(
        'data:image/jpg;base64,' + sessionStorage.getItem('lkighty445dh==WhatsAppQR')
      );
      if (WhatsAppQR && WhatsAppQR != 'null') {
        this.WhatsAppQR = WhatsAppQR;
      }
      this.WhatsAppLink = this.sanitizer.bypassSecurityTrustResourceUrl(sessionStorage.getItem('lkighty445dh==WhatsAppLink'));
    }, 1000);

    // setTimeout(()=>{
    //   this.logoimage = sessionStorage.getItem('lkighty445dh==');
    //   this.CompanyLogo = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,'+ this.logoimage);
    // },1000)
    this.Googleplaylink = this.sanitizer.bypassSecurityTrustResourceUrl(
      sessionStorage.getItem('ihjt45h45=t')
    );
    $(document).ready(function () {
      $('.openNav').click(function () {
        // $('#mySidenav').animate({'width':'100%'},20);
        $('#mySidenav').addClass('SlideOpen');
        $('#mySidenav').removeClass('SlideClose');
        $('#mySidenavDesktop').addClass('SlideOpen');
        $('#mySidenavDesktop').removeClass('SlideClose');
      });
      $('.sidebar-mask').click(function () {
        // $('#mySidenav').animate({'width':'0%'},20);
        $('#mySidenav').removeClass('SlideOpen');
        $('#mySidenav').addClass('SlideClose');
        $('#mySidenavDesktop').removeClass('SlideOpen');
        $('#mySidenavDesktop').addClass('SlideClose');
      });
      $('.closebtn').click(function () {
        // $('#mySidenav').animate({'width':'0%'},20);
        $('#mySidenav').removeClass('SlideOpen');
        $('#mySidenav').addClass('SlideClose');
        $('#mySidenavDesktop').removeClass('SlideOpen');
        $('#mySidenavDesktop').addClass('SlideClose');
      });
      $('img.svg').each(function () {
        var $img = $(this);
        var imgID = $img.attr('id');
        var imgClass = $img.attr('class');
        var imgURL = $img.attr('src');

        $.get(
          imgURL,
          function (data) {
            // Get the SVG tag, ignore the rest
            var $svg = $(data).find('svg');

            // Add replaced image's ID to the new SVG
            if (typeof imgID !== 'undefined') {
              $svg = $svg.attr('id', imgID);
            }
            // Add replaced image's classes to the new SVG
            if (typeof imgClass !== 'undefined') {
              $svg = $svg.attr('class', imgClass + ' replaced-svg');
            }

            // Remove any invalid XML tags as per http://validator.w3.org
            $svg = $svg.removeAttr('xmlns:a');

            // Replace image with new SVG
            $img.replaceWith($svg);
          },
          'xml'
        );
      });

      $('.accordion_head').click(function () {
        if ($('.accordion_body').is(':visible')) {
          $('.accordion_body').slideUp(300);
          $('.plusminus').text('+');
        }
        if ($(this).next('.accordion_body').is(':visible')) {
          $(this).next('.accordion_body').slideUp(300);
          $(this).children('.plusminus').text('+');
        } else {
          $(this).next('.accordion_body').slideDown(300);
          $(this).children('.plusminus').text('-');
        }
      });
    });
  }
  modalPopOpen() {
    $('#LetsTalk_popup').modal('show');
  }
  OnSubmittoonboard() {
    this.router.navigateByUrl('distributor-onboarding');
  }
  CallAlertModal(msg: any) {
    $('#AlertModal').modal({ backdrop: 'static', keyboard: false });
    $('#AlertModalContent').text(msg);
  }
  onsubmitLetsTalkForm() {
    debugger;
    this.LetsTalkForm.controls['talk_schedule1'].setValue(this.scheduleofcall);
    if (this.LetsTalkForm.invalid) {
      return;
    } else {
      debugger;
      const json = {
        customer_name: this.LetsTalkForm.controls['customer_name'].value,
        Mobile_No: this.LetsTalkForm.controls['Mobile_No'].value,
        customer_Email: this.LetsTalkForm.controls['customer_Email'].value,
        Statein: this.LetsTalkForm.controls['Statein'].value,
        city_name: this.LetsTalkForm.controls['city_name'].value,
        customer_Meassage:
          this.LetsTalkForm.controls['customer_Meassage'].value,
        talk_schedule1: this.LetsTalkForm.controls['talk_schedule1'].value,
        DomainName: window.location.host,
        S_Brokerid: this.subBrokerID_mail
      };
      let DataBody = JSON.stringify(json);
      debugger;
      this.profileService
        .PostMailToMFLetstalkform(DataBody)
        .subscribe((result: any) => {
          this.dataSource = result;

          if (this.dataSource.code == 200) {
            this.CallAlertModal('Connect You Soon');
          }
          //this.CallAlertModalProfile(this.dataSource.ArrayOfResponse[0].message);

          this.LetsTalkForm.controls['customer_name'].setValue('');
          this.LetsTalkForm.controls['Mobile_No'].setValue('');
          this.LetsTalkForm.controls['customer_Email'].setValue('');
          this.LetsTalkForm.controls['Statein'].setValue('');
          this.LetsTalkForm.controls['city_name'].setValue('');
          this.LetsTalkForm.controls['customer_Meassage'].setValue('');
          this.LetsTalkForm.controls['talk_schedule1'].setValue('');
          $('#LetsTalk_popup').modal('hide');
        });
    }
  }
  Scheduletimecall(e) {
    this.scheduleofcall = e.target.value;
  }

  OpenModalForAppQR() {
    $('#AppQRModal').modal({ backdrop: 'static', keyboard: false });
  }

  SetViewPort(w) {
    if (w <= 767) {
      this.IsMobile = true;
    } else {
      this.IsMobile = false;
    }
  }
}
